export default "__VITE_ASSET__CcrvDGuf__"